import {
  B3,
  getTranslatedText,
  reactSelectErrorStyles,
  reactSelectInlineError,
  T3
} from '@nile/components';
import {
  DropdownIndicator,
  IndicatorSeparator
} from '@nile/components/src/Pebbles/select';
import { TextField } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Select from 'react-select';
import styled from 'styled-components';

const VariableCardWrapper = styled.div`
  border: 1px solid #ebebeb;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  .Polaris-TextField {
    margin-bottom: 0 !important;
  }
  .icon {
    padding: 13px 20px;
    background: #f2f2f7;
  }
  .input {
    flex: 2;
    margin: 0 25px;
    &.dual {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .separator {
      font-size: 24px;
      font-weight: 100;
      color: #bdbdbd;
    }
  }
  .actionBtn {
    padding: 10px;
    visibility: hidden;
    cursor: pointer;
  }
  &:hover {
    .actionBtn {
      visibility: visible;
    }
  }
`;
function camelCaseToLabel(camelCaseStr) {
  return camelCaseStr
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
}
const VariableInput = ({
  variable,
  index,
  handleVariableUpdate,
  intl,
  error,
  isRunScript = false,
  disabled = false,
  formatLabel = false
}) => {
  const [value, setValue] = useState('');
  const setSelectedOption = (val) => {
    handleVariableUpdate(index, val?.value);
  };

  return (
    <VariableCardWrapper className="fx">
      <div className="icon">
        <T3>$</T3>
      </div>
      <div className="input dual">
        <B3 className={isRunScript && 'f11'}>
          {formatLabel ? (
            camelCaseToLabel(variable?.label || variable.name)
          ) : (
            <FormattedMessage id={variable?.label || variable.name} />
          )}
        </B3>
        <div className={`separator ${isRunScript && 'mr-10'}`}>|</div>
        {variable?.options ? (
          <div
            style={{ width: '50%', marginBottom: '5px' }}
            className={isRunScript && 'f11'}
          >
            <Select
              isDisabled={disabled}
              value={
                variable.options
                  .filter((opt) => opt.value === variable.value)
                  ?.map((opt) => ({
                    ...opt,
                    label: getTranslatedText(intl, opt.label)
                  }))?.[0] || null
              }
              label={getTranslatedText(
                intl,
                'asset.runscript.script.select.label'
              )}
              options={variable.options.map((opt) => ({
                ...opt,
                label: getTranslatedText(intl, opt.label)
              }))}
              // onChange={(item) => handleChange('language', item.value)}
              onChange={setSelectedOption}
              components={{ IndicatorSeparator, DropdownIndicator }}
              classNamePrefix="value_selector"
              menuPlacement="auto"
              menuPortalTarget={document.body}
              placeholder={getTranslatedText(
                intl,
                isRunScript
                  ? 'admin.runbook.runscript.placeholder'
                  : 'asset.runscript.script.select.placeholder'
              )}
              closeMenuOnScroll={(e) => {
                return (
                  e.target &&
                  e.target.classList &&
                  !(e.target.classList.value.indexOf('menu-list') > -1)
                );
              }}
              styles={
                error?.value
                  ? {
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      ...reactSelectErrorStyles
                    }
                  : {
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 })
                    }
              }
              isSearchable={false}
              isClearable={Boolean(isRunScript)}
            />
            {error?.value && reactSelectInlineError(error.value)}
          </div>
        ) : (
          <div className={isRunScript && 'f11'}>
            <TextField
              value={variable.value}
              onChange={(val) => handleVariableUpdate(index, val)}
              placeholder={getTranslatedText(
                intl,
                'asset.runscript.script.variable.placeholder'
              )}
              error={error?.value}
              noborder
              disabled={disabled}
            />
          </div>
        )}
      </div>
    </VariableCardWrapper>
  );
};

export default injectIntl(VariableInput);
